import React from "react";
import { connect } from "react-redux";
import {
  array,
  bool,
  func,
  number,
  object,
  oneOfType,
  string,
} from "prop-types";
import cloneDeep from "lodash/cloneDeep";
import { Row, Col, Button, Form, Modal, Badge } from "react-bootstrap";
import { getTestTypeBadgeClassName } from "containers/JobSetup/helpers";
import clockIcon from "resources/images/clock-2x.png";
import { getCompanyInfo } from "containers/App/actions";
import InvitationSettings from "components/InvitationSettings/InvitationSettings";
import TestBatteryInfoCards from "components/InvitationSettings/TestBatteryInfoCards";
import AssessmentInfoBox from "components/InvitationSettings/AssessmentInfoBox";
import { getEventProctoringSettings } from "containers/Scheduling/helpers";
import { subTestIdToSubTestName } from "containers/TestBatteries/constants";
import { getDefaultEmailTemplateId, getTestTime } from "utils/helperFunctions";
import {
  getProctoringDefaultConfiguration,
  PROCTORING_CONFIGURATION_DEFAULT_SETTINGS,
} from "utils/proctoringHelpers";
import closeButton from "resources/images/close-blue.png";
import {
  rescheduleTests,
  rescheduleVideoInterview,
  getTestBatteries,
} from "../../actions";
import TestingTabs from "./TestingTabs";

export class ScheduleTest extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      batteryIdChosen: false,
      currentTab: null,
      emailTemplateChosen: "default",
      hoursDelay: 0,
      reuseResults: { months: null, reuseEnabled: null },
      notifyEmail: true,
      reuseCandidateResults: null,
      supervised: false,
      testsChosen: {},
      timeFactor: 1.0,
      videoInterview: false,
      availableSubTests: {},
      screenReaderCompatibility: false,
      proctoring: false,
      proctoringConfiguration:
        PROCTORING_CONFIGURATION_DEFAULT_SETTINGS.disabled, // initialized to disabled
    };
  }

  UNSAFE_componentWillMount() {
    const {
      savedTestBatteries,
      companyInfo,
      onGetTestBatteries,
      onLoadTestMakerTests,
      jobs,
      jobData,
      jobId,
      candidateStageId,
    } = this.props;

    this.props.onGetCompanyInfo();
    onLoadTestMakerTests();
    if (savedTestBatteries.size === 0) {
      onGetTestBatteries();
    }
    const job = jobs.get(String(jobId));
    const availableSubTests = {};

    // 0 = default | null = ignore job default
    if (job && companyInfo) {
      this.setState({
        emailTemplateChosen: String(
          getDefaultEmailTemplateId(
            companyInfo.get("defaultScheduleEmailTemplateId"),
            job.get("invitationEmailTemplateId"),
            this.props.vhs
          )
        ),
      });
    }
    const batteryIdChosen = job.get("batteries")
      ? String(job.get("batteries").get("data").first().get("testBatteryId"))
      : false;
    const videoInterview =
      job.get("videoInterviews") &&
      job
        .get("videoInterviews")
        .find(
          (viObject) =>
            viObject.get("active") &&
            viObject.get("pipelineStageMapId") === candidateStageId
        );
    if (
      jobData &&
      jobData.get("batteries") &&
      jobData.get("batteries").get("data")
    ) {
      jobData
        .get("batteries")
        .get("data")
        .forEach((battery) => {
          battery.forEach(([testObj]) => {
            availableSubTests[
              testObj.get("testId").includes("TM")
                ? testObj.get("testId")
                : testObj.get("subTestId")
            ] = testObj;
          });
        });
    }

    const timeFactor = (jobData && jobData.get("timeFactor")) || 1.0;

    const screenReaderCompatibility = !!(
      jobData && jobData.get("screenReaderCompatibility")
    );

    const proctoring = !!jobData?.get("proctoringSettings")?.get("enabled");

    const proctoringConfiguration =
      jobData?.get("proctoringSettings")?.get("configuration")?.toJS() ||
      getProctoringDefaultConfiguration(
        this.props.companyInfo.get("platformProctoringEnabled"),
        proctoring
      );

    this.setState({
      batteryIdChosen,
      videoInterview,
      availableSubTests,
      timeFactor,
      screenReaderCompatibility,
      proctoring,
      proctoringConfiguration,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.companyInfo.get("defaultScheduleEmailTemplateId") !==
      this.props.companyInfo.get("defaultScheduleEmailTemplateId")
    ) {
      this.setState({
        emailTemplateChosen: String(
          nextProps.companyInfo.get("defaultScheduleEmailTemplateId")
        ),
      });
    }

    // Set up reuse results
    if (
      nextProps.companyInfo &&
      nextProps.jobs &&
      nextProps.jobId &&
      nextProps.jobs.get(nextProps.jobId) &&
      this.state.reuseCandidateResults === null
    ) {
      // Default to job level reuse results
      const reuseResultsEnabled =
        nextProps.jobs.get(nextProps.jobId).get("jobReuseResults") === 1;

      const reuseCandidateResults = reuseResultsEnabled;

      const reuseMonths = nextProps.jobs
        .get(nextProps.jobId)
        .get("jobReuseMonths");

      const reuseResults = {
        months: reuseMonths,
        reuseEnabled: reuseResultsEnabled,
      };

      this.setState({ reuseResults, reuseCandidateResults });
    }
  }

  handleChangeAction = (isActionDone) => {
    this.props.changeAction(false, isActionDone);
  };

  handleAdjustedTimeMultiplier = (event) => {
    this.setState({ timeFactor: event.value });
  };

  handleSelectHoursDelay = (event) => {
    this.setState({ hoursDelay: event.value });
  };

  handleChangeEmailTemplateId = (event) => {
    this.setState({ emailTemplateChosen: event.value });
  };

  handleChooseBattery = (e) => {
    const batteryId = e.target.value;
    if (batteryId === this.state.batteryIdChosen) {
      this.setState({ batteryIdChosen: false });
    } else {
      this.setState({ batteryIdChosen: batteryId });
    }
  };

  handleSubTestChoice = ({ value: { subTestId, parentTestId } }) => {
    this.setState((prevState) => {
      const testsChosen = cloneDeep(prevState.testsChosen);
      if (testsChosen[subTestId]) {
        delete testsChosen[subTestId];
      } else {
        testsChosen[parentTestId.includes("TM") ? parentTestId : subTestId] = {
          TM: parentTestId.toLowerCase().indexOf("tm") > -1,
        };
      }
      return { testsChosen };
    });
  };

  handleRemoveSubTestChoice = (subTestId) => {
    this.setState((prevState) => {
      const testsChosen = cloneDeep(prevState.testsChosen);
      delete testsChosen[subTestId];
      return { testsChosen };
    });
  };

  handleChangeNotifyEmail = (event) => {
    const notifyEmail = event.target.checked;

    this.setState({ notifyEmail });

    if (!notifyEmail) {
      this.setState({ hoursDelay: 0 });
    }
  };

  handleChangeReuseResults = () => {
    this.setState((prevState) => ({
      reuseCandidateResults: !prevState.reuseCandidateResults,
    }));
  };

  handleChangeScreenReaderCompatibility = () => {
    this.setState((prevState) => ({
      screenReaderCompatibility: !prevState.screenReaderCompatibility,
    }));
  };

  handleScheduleTesting = () => {
    let emailTemplateId; // 0 for criteria default, null for no email, id otherwise
    if (
      this.state.emailTemplateChosen === "default" &&
      this.state.notifyEmail
    ) {
      emailTemplateId = 0;
    } else {
      emailTemplateId = this.state.notifyEmail
        ? this.state.emailTemplateChosen
        : null;
    }
    // If the job has a VI in the incoming stage we shall be hitting another endpoint
    // so lets jump to handleScheduleVideoInterview function and exit this function.
    // if (this.state.currentTab === 'videoInterview') {
    //   return this.handleScheduleVideoInterview(emailTemplateId);
    // }

    // if job level reuse results are enabled, we will show the candidate level reuse results and send the value
    // if candidate level reuse results are not shown, we will not send the overrideReuseResults field and backend will set to null
    const sendReuseResultsOverride =
      this.state.reuseResults && this.state.reuseResults.reuseEnabled;

    const { companyInfo, jobData } = this.props;

    const includeProctoringSettingsInPayload =
      companyInfo?.get("platformProctoringEnabled") &&
      jobData?.get("proctoringSettings")?.get("enabled");

    const proctoringSettings = getEventProctoringSettings(
      this.state.proctoring,
      this.state.supervised,
      this.state.proctoringConfiguration
    );

    const dataToSend = {
      emailTemplateId,
      ...(sendReuseResultsOverride && {
        overrideReuseResults: this.state.reuseCandidateResults,
      }),
      supervised: this.state.supervised,
      ...(this.state.notifyEmail && { hoursDelay: this.state.hoursDelay }),
      testTakerIds: this.props.candidateIds,
      testBatteryId: null,
      timeFactor: this.state.timeFactor !== 1.0 ? this.state.timeFactor : null,
      customizableResults: this.props.userData.resultsV2 !== 0,
      screenReaderCompatibility: this.state.screenReaderCompatibility,
      ...(includeProctoringSettingsInPayload && { proctoringSettings }),
    };

    const chosenTestIds = Object.keys(this.state.testsChosen);
    if (this.state.batteryIdChosen !== false) {
      dataToSend.testBatteryId = this.state.batteryIdChosen;
    } else if (chosenTestIds.length > 0) {
      dataToSend.tests = [];
      chosenTestIds.forEach((subTestId) => {
        const idToSend = this.state.testsChosen[subTestId].TM
          ? { testMakerTestId: subTestId.slice(2) }
          : { subTestId };
        dataToSend.tests.push(idToSend);
      });
    } else {
      return alert(
        "Please select a test battery or individual tests to schedule"
      );
    }

    const externalIdOn =
      this.props.companyInfo && this.props.companyInfo.get("externalIdOn");

    this.props.onRescheduleTests(
      dataToSend,
      this.props.jobId,
      this.props.candidateName,
      externalIdOn
    );
    this.handleChangeAction(true);
  };

  // handleScheduleVideoInterview(emailTemplateId) {
  //   const dataToSend = {
  //     emailTemplateId,
  //     jobDetailId: this.props.jobId,
  //     jobVideoInterviewId: this.state.videoInterview.get("jobVideoInterviewId"),
  //   };

  //   const externalIdOn =
  //     this.props.companyInfo && this.props.companyInfo.get("externalIdOn");

  //   this.props.onRescheduleVideoInterview(
  //     this.props.candidateIds[0],
  //     dataToSend,
  //     externalIdOn
  //   );
  // }

  onSelectTab = (tab) => {
    this.setState({ currentTab: tab });

    if (tab === "selectBattery") {
      const defaultTestBatteryChosen = String(
        this.props.jobs
          .get(this.props.jobId)
          .get("batteries")
          .get("data")
          .first()
          .get("testBatteryId")
      );

      this.setState({
        batteryIdChosen: defaultTestBatteryChosen,
        testsChosen: {},
      });
    } else {
      this.setState({ batteryIdChosen: false });
    }
  };

  handleSupervisedOnChange = (event) => {
    // form.check value is coalesced to a string so we need to convert the value into a number
    const supervised = Number(event.target.value);

    this.setState({ supervised });

    if (supervised) {
      this.setState({ hoursDelay: 0, notifyEmail: false });
    } else {
      this.setState({ notifyEmail: true });
    }
  };

  handleChangeProctoring = (event, configuration) => {
    // Safety check to ensure event and event.target exist
    if (!event || !event.target) {
      return;
    }

    // Determine if this is the main proctoring toggle or a sub-feature toggle
    const isMainToggle = event.target.id === "candidate-proctoring";

    if (isMainToggle) {
      const mainToggleStatus = event.target.checked;
      // Set all child toggles to match the main toggle state
      this.setState({
        proctoring: mainToggleStatus,
        proctoringConfiguration: getProctoringDefaultConfiguration(
          this.props.companyInfo?.get("platformProctoringEnabled"),
          mainToggleStatus
        ),
      });
    } else if (configuration) {
      // This is a sub-feature toggle - leave the main toggle as is
      this.setState({
        proctoringConfiguration: configuration,
      });
    }
  };

  render() {
    const {
      currentTab,
      batteryIdChosen,
      testsChosen,
      videoInterview,
      emailTemplateChosen,
      hoursDelay,
      notifyEmail,
      reuseCandidateResults,
      reuseResults,
      supervised,
      timeFactor,
      availableSubTests,
      screenReaderCompatibility,
      proctoring,
      proctoringConfiguration,
    } = this.state;

    const {
      companyInfo,
      jobData,
      featureFlags,
      fromBulkSendTestInvitation,
      vhs,
      testMakerTests,
      userData,
      savedEmailTemplates,
      savedTestBatteries,
    } = this.props;

    const isAU = userData && userData.locale === "AU";
    const showTimeFactor = userData && userData.showTimeFactor;

    const isProctoringOptedIn = companyInfo?.get("platformProctoringEnabled");
    const jobProctoringEnabled = jobData
      ?.get("proctoringSettings")
      ?.get("enabled");

    const showProctoring =
      isProctoringOptedIn && jobProctoringEnabled && !supervised;

    const jobsBatteries =
      jobData.get("batteries") && jobData.get("batteries").get("data");
    const inviteButtonDisabled =
      (currentTab === "selectBattery" && batteryIdChosen === false) ||
      (currentTab === "selectSpecificTest" &&
        Object.keys(testsChosen).length === 0);

    const TestBatteryInfoOptions = {};
    const IndividualTestsOptions = {};
    const chosenTestComponents = [];
    let testBatteryChosenSubTests = null;

    if (jobsBatteries) {
      jobsBatteries.forEach((subTestArray, batteryId) => {
        if (Object.keys(TestBatteryInfoOptions).includes(batteryId)) {
          return;
        }

        // Default battery chosen will be the first test battery in the list
        const isBatteryChosen = `${batteryId}` === batteryIdChosen;
        const subTests = subTestArray.map((subTestObj) => subTestObj.first());
        const testBatteryName = subTests.first().get("testBatteryName");
        const sortedSubTests = subTests.sort(
          (a, b) => a.get("subTestOrder") - b.get("subTestOrder")
        );
        const individualTestChosenIds = Object.keys(testsChosen);
        const IndividualTestsBadgeList = [];

        // if selecting an individual test, filter through each test battery and set testBatteryChosenSubTests to only the test data that fits the criteria
        if (individualTestChosenIds.length > 0) {
          testBatteryChosenSubTests = sortedSubTests
            .filter((subTest) => {
              const idToUse = subTest.get("testId").includes("TM")
                ? subTest.get("testId")
                : subTest.get("subTestId");
              if (individualTestChosenIds.includes(`${idToUse}`)) {
                chosenTestComponents.push(
                  <Row>
                    <Col>
                      <AssessmentInfoBox
                        timeFactor={timeFactor}
                        test={availableSubTests[`${idToUse}`]}
                        assessmentSettings={jobData.get("assessmentSettings")}
                      />
                    </Col>
                    <Col sm={2} className="p-0 d-flex align-items-center">
                      <Button
                        variant="outline-primary"
                        className="btn-cancel"
                        onClick={() => {
                          this.handleRemoveSubTestChoice(`${idToUse}`);
                        }}
                      >
                        <img
                          src={closeButton}
                          alt="close"
                          height="16px"
                          width="16px"
                          className="mr-2 mb-1"
                        />{" "}
                        Remove
                      </Button>
                    </Col>
                  </Row>
                );
                return true;
              }
            })
            .merge(testBatteryChosenSubTests);
        } else if (isBatteryChosen) {
          testBatteryChosenSubTests = sortedSubTests;
        }

        let totalTime = 0;
        sortedSubTests.forEach((subTestObj, parentTestId) => {
          totalTime += getTestTime(subTestObj);

          const subTestId = `${
            subTestObj.get("testId").includes("TM")
              ? subTestObj.get("testId")
              : subTestObj.get("subTestId")
          }`;

          const badgeClassName = getTestTypeBadgeClassName(
            subTestObj.get("testType")
          );
          const testMakerTestFullName = subTestObj.get("testId").includes("TM")
            ? subTestObj.get("subTestName")
            : "";
          const testName = subTestObj.get("testId").includes("TM")
            ? `${subTestObj.get("testMakerTestName").substring(0, 6)}...`
            : subTestObj.get("subTestAbbreviation");

          IndividualTestsBadgeList.push(
            <Badge
              key={subTestObj.get("testId")}
              title={testMakerTestFullName}
              bsPrefix={`badge-list-badge ${badgeClassName}`}
              className="text-center test-type mb-0 mr-2 mt-2"
              style={{ letterSpacing: "0.5px" }}
            >
              {testName}
            </Badge>
          );

          // add each subtest to individualSubTestIds array so that we do not show duplicate sub tests in the Select Specific Test(s) tab
          if (
            !Object.keys(IndividualTestsOptions).includes(subTestId) &&
            !individualTestChosenIds.includes(subTestId)
          ) {
            let label =
              subTestObj.get("subTestName") ||
              subTestObj.get("testMakerTestName");

            if (String(parentTestId) === "56") {
              label = "Cognitive Aptitude Test - DFR Use Only";
            } else if (String(parentTestId) === "46") {
              label = subTestIdToSubTestName[subTestId];
            }

            IndividualTestsOptions[subTestId] = {
              value: { subTestId, parentTestId },
              label,
            };
          }
        });

        TestBatteryInfoOptions[batteryId] = (
          <Row
            key={batteryId} // eslint-disable-line react/no-array-index-key
            className="px-3 py-2 mx-0 my-auto"
            style={{ borderBottom: "1px solid #d8d9d9" }}
          >
            <Col
              sm={isBatteryChosen ? 12 : 6}
              md={isBatteryChosen ? 12 : 6}
              lg={isBatteryChosen ? 12 : 6}
            >
              <Form.Group className="mt-3">
                <Form.Check
                  type="radio"
                  value={batteryId}
                  name="testBattery"
                  className="font-weight-bold"
                  style={{ fontSize: "16px" }}
                  checked={isBatteryChosen}
                  onChange={this.handleChooseBattery}
                  label={testBatteryName}
                />
              </Form.Group>
              {isBatteryChosen && (
                <div className="mb-2">
                  <TestBatteryInfoCards
                    testBatterySubTests={sortedSubTests}
                    fromScheduleExistingCandidates
                    assessmentSettings={jobData.get("assessmentSettings")}
                    timeFactor={timeFactor}
                  />
                </div>
              )}
            </Col>{" "}
            {!isBatteryChosen && (
              <Col
                sm={6}
                md={6}
                lg={6}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                }}
              >
                <div className="text-left mt-2 mr-2">
                  {IndividualTestsBadgeList}
                </div>
                <div
                  className="my-auto"
                  style={{ display: "flex", flexDirection: "row" }}
                >
                  <img
                    src={clockIcon}
                    height="16"
                    width="16"
                    alt="clock"
                    className="mt-1"
                  />
                  <div
                    className="pl-1 mt-1"
                    style={{ color: "#86888b", lineHeight: "16px" }}
                  >
                    <img
                      src={clockIcon}
                      height="16"
                      width="16"
                      alt="clock"
                      className="mt-1"
                    />
                    <div
                      className="pl-1 mt-1"
                      style={{ color: "#86888b", lineHeight: "16px" }}
                    >
                      {`${totalTime}m`}
                    </div>
                  </div>
                </div>
              </Col>
            )}
          </Row>
        );
      });
    }

    return (
      <div
        style={
          fromBulkSendTestInvitation
            ? { overflowY: "scroll", maxHeight: "750px" }
            : undefined
        }
      >
        <Modal.Header>
          <h4>
            Send {videoInterview ? "Assessment" : "Test"} Invitation{" "}
            {fromBulkSendTestInvitation
              ? `to ${this.props.candidateIds.length} Candidates`
              : null}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg={12} md={12} sm={12}>
              <TestingTabs
                testBatteries={Object.values(TestBatteryInfoOptions)}
                individualTestOptions={Object.values(IndividualTestsOptions)}
                batteryIdChosen={batteryIdChosen}
                onSelectTab={this.onSelectTab}
                chosenTests={chosenTestComponents}
                currentCandidateStageHasVi={videoInterview}
                handleSubTestChoice={this.handleSubTestChoice}
              />
            </Col>
          </Row>
          <Row className="mt-5">
            <Col>
              <InvitationSettings
                companyInfo={companyInfo}
                emailTemplateId={emailTemplateChosen}
                emailTemplates={savedEmailTemplates}
                fromScheduleExistingCandidates
                handleAdjustedTimeMultiplier={this.handleAdjustedTimeMultiplier}
                handleChangeEmailTemplateId={this.handleChangeEmailTemplateId}
                handleChangeNotifyEmail={this.handleChangeNotifyEmail}
                handleChangeReuseResults={this.handleChangeReuseResults}
                handleSelectHoursDelay={this.handleSelectHoursDelay}
                handleSupervisedOnChange={this.handleSupervisedOnChange}
                hoursDelay={hoursDelay}
                isAU={isAU}
                job={jobData}
                notifyEmail={notifyEmail}
                reuseCandidateResults={reuseCandidateResults}
                reuseResults={reuseResults}
                showTimeFactor={showTimeFactor}
                supervised={supervised}
                testBatterySubTests={testBatteryChosenSubTests}
                timeFactor={timeFactor}
                vhs={vhs}
                testBatteryChosen={savedTestBatteries.get(batteryIdChosen)}
                testMakerTests={testMakerTests}
                featureFlags={featureFlags}
                screenReaderCompatibility={screenReaderCompatibility}
                handleChangeScreenReaderCompatibility={
                  this.handleChangeScreenReaderCompatibility
                }
                showProctoring={showProctoring}
                proctoring={proctoring}
                handleChangeProctoring={this.handleChangeProctoring}
                proctoringConfiguration={proctoringConfiguration}
                isProctoringOptedIn={isProctoringOptedIn}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => this.handleChangeAction(false)}
            id="cancelScheduleTest"
            variant="outline-primary"
            className="btn-cancel"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={this.handleScheduleTesting}
            id="scheduleTest"
            disabled={inviteButtonDisabled}
          >
            Invite
          </Button>
        </Modal.Footer>
      </div>
    );
  }
}

ScheduleTest.propTypes = {
  changeAction: func,
  savedEmailTemplates: object,
  savedTestBatteries: oneOfType([object, array]),
  onRescheduleTests: func,
  // onRescheduleVideoInterview: func,
  onGetTestBatteries: func,
  onGetCompanyInfo: func,
  candidateIds: array,
  candidateName: string,
  jobs: object,
  jobData: object,
  jobId: oneOfType([string, number]),
  companyInfo: object,
  vhs: number,
  fromBulkSendTestInvitation: bool,
  onLoadTestMakerTests: func,
  testMakerTests: object,
  userData: object,
  featureFlags: object,
  candidateStageId: oneOfType([string, number]),
};

const mapStateToProps = (state) => ({
  companyInfo: state.get("App").get("companyInfo"),
  featureFlags: state.get("App").get("featureFlags"),
  jobs: state.get("results").get("jobs"),
  savedEmailTemplates: state.get("results").get("savedEmailTemplates"),
  savedTestBatteries: state.get("results").get("savedTestBatteries"),
  vhs: state.get("App").get("vhs"),
  userData: state.get("App").get("userData"),
});

const mapDispatchToProps = (dispatch) => ({
  onRescheduleTests: (data, jobId, candidateName, externalIdOn) =>
    dispatch(rescheduleTests(data, jobId, candidateName, externalIdOn)),
  onRescheduleVideoInterview: (testTakerId, data, externalIdOn) => {
    dispatch(rescheduleVideoInterview(testTakerId, data, externalIdOn));
  },
  onGetTestBatteries: () => dispatch(getTestBatteries()),
  onGetCompanyInfo: () => dispatch(getCompanyInfo()),
});
export default connect(mapStateToProps, mapDispatchToProps)(ScheduleTest);
